import { useEditorState } from "@/store";

interface ComplementaryFrameProps {
  projectId: string;
}

export function ComplementaryFrame({ projectId }: ComplementaryFrameProps) {
  const language = useEditorState((state) => state.language);
  const godotContainerRef = useEditorState((state) => state.godotContainerRef);
  
  const stripped = projectId.substring("complementary;".length);
  const urlPath = stripped.replace(";", "/");
  const hasQueryParams = urlPath.includes("?");
  const finalUrl = `https://sim.riders.ai/${urlPath}${hasQueryParams ? "&" : "?"}language=${language}`;
  
  return <iframe ref={godotContainerRef} src={finalUrl} style={{ width: "100%", height: "100%", border: "none" }} />;
}
